import { render, staticRenderFns } from "./DwPzvip.vue?vue&type=template&id=5d4f664c&scoped=true&"
import script from "./DwPzvip.vue?vue&type=script&lang=js&"
export * from "./DwPzvip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f664c",
  null
  
)

export default component.exports